export const blockIconsEditorFormatBold = (
	<span className='material-symbols-outlined'>format_bold</span>
);
